'use strict';

var naPhone = /^\(?([2-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/;
var regex = {
    email: /^[\w.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/,
    phone: {
        us: naPhone,
        ca: naPhone,
        fr: /^0[1-6]{1}(([0-9]{2}){4})|((\s[0-9]{2}){4})|((-[0-9]{2}){4})$/,
        it: /^(([0-9]{2,4})([-\s\/]{0,1})([0-9]{4,8}))?$/,
        jp: /^(0\d{1,4}- ?)?\d{1,4}-\d{4}$/,
        cn: /.*/,
        gb: /^((\(?0\d{4}\)?\s?\d{3}\s?\d{3})|(\(?0\d{3}\)?\s?\d{3}\s?\d{4})|(\(?0\d{2}\)?\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/
    },
    postal: {
        us: /^\d{5}(-\d{4})?$/,
        ca: /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/,
        fr: /^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/,
        it: /^([0-9]){5}$/,
        jp: /^([0-9]){3}[-]([0-9]){4}$/,
        cn: /^([0-9]){6}$/,
        gb: /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/
    },
    notCC: /^(?!(([0-9 -]){13,19})).*$/,
    password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d.*)(?=.*\W.*)[a-zA-Z0-9\S]{8,255}$/
};
// global form validator settings
var settings = {
    errorClass: 'error',
    errorElement: 'span',
    onkeyup: false,
    onfocusout: function (element) {
        if (!this.checkable(element)) {
            this.element(element);
        }
    }
};
var customValidatorsInitialized = false;

/**
 * @function
 * @description Validates a given phone number against the countries phone regex
 * @param {String} value The phone number which will be validated
 * @param {String} el The input field
 */
var validatePhone = function (value, el) {
    var $country   = $(el).closest('form').find('.country');
    var countryVal = ($country.val() === undefined) ? 'us' : $country.val();
    var regexCheck = regex.phone[countryVal.toLowerCase()];

    if (!regexCheck) {
        return true;
    }

    return this.optional(el) || regexCheck.test($.trim(value));
};

/**
 * @function
 * @description Validates the credit card expiration date
 * @param {Number} value The expiration month
 */
var validateCCExpirationDate = function(value) {
    var exMonth      = value;
    var exYear       = $('select[name$="_expiration_year"] option:selected').val();
    var today        = new Date();
    var selectedDate = new Date();
    selectedDate.setFullYear(exYear, exMonth, 1);

    if (selectedDate < today) {
       return false;
    }

    return true;
};

/**
 * @function
 * @description Validates that a credit card owner is not a Credit card number
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateOwner = function (value) {
    var isValid = regex.notCC.test($.trim(value));
    return isValid;
};

/** @function
 * @description Validates email
 * @param {String} email field value
 * @param {String} el The input field
 */
var validateEmail = function (value, el) {
    return regex.email.test(value);
};

/**
 * @function
 * @description Validates that an email and email confirmation fields match
 * @param {String} value The email confirmation
 * @param {String} el The input field
 */
var validateEmailConfirm = function (value, el) {
    var email = $(el).closest('form').find('input[name*="_email"]').val();
    return email == value;
};

/**
 * @function
 * @description Validates that checkbox is checked
 * @param {String} value The checkbox confirmation
 * @param {String} el The input field
 */
var validateCheckbox = function (value, el) {
    var isChecked = $(el).closest('form').find('input[name*="_checkbox"]').is(':checked');
    return isChecked;
};

/**
 * @function
 * @description Validates that an password and password confirmation fields match
 * @param {String} value The password confirmation
 * @param {String} el The input field
 */
var validatePassword = function (value, el) {
    var password = $(el).closest('form').find('input[name*="_password"]').val();
    return password == value;
};

/**
 * @function
 * @description Validates that an password and password confirmation fields match
 * @param {String} value The new password confirmation
 * @param {String} el The input field
 */
var validateNewPassword = function (value, el) {
    var password = $(el).closest('form').find('input[name*="_newpassword"]').val();
    return password == value;
};

/**
 * @function
 * @description Validates that an password and password confirmation fields match
 * @param {String} value The new password confirmation
 * @param {String} el The input field
 */
var validatePasswordComplexity = function (value) {
    var isValid = regex.password.test($.trim(value));
    return isValid;
};

/**
 * @function
 * @description Validates a search query
 * @param {String} value The query which will be validated
 */
var validateSearch = function (value) {
    return (value.trim() != '');
};

/**
 * @function
 * @description Validates a given postal code number against the countries postal regex
 * @param {String} value The postal code which will be validated
 * @param {String} el The input field
 */
var validatePostal = function(value, el) {
    var $country   = $(el).closest('form').find("select[name$='country']");
    var countryVal = ($country.val() === undefined) ? 'us' : $country.val();
    var regexCheck = regex.postal[countryVal.toLowerCase()];

    if (!regexCheck) {
        return true;
    }

    return regexCheck.test($.trim(value));
};

var validateGiftcertPurchaseAmount = function(value, el) {
    var $el = $(el);
    // [AOBC-3169] treat ',' char as thousands separator (to be consistent with BD implementation),
    // must remove it before converting to number
    var floatVal = parseFloat(value.replace(',', ''));

    return floatVal >= parseInt($el.data('min')) && floatVal <= parseInt($el.data('max'));
};

$.validator.addMethod('giftcert-purchase-amount', validateGiftcertPurchaseAmount, window.Resources.GC_AMOUNT_MINMAX);

/**
 * Add search validation method to jQuery validation plugin.
 * Text fields must have 'search' css class to be validated
 */
$.validator.addMethod('search', validateSearch, Resources.INVALID_SEARCH);

$.validator.addMethod('validate-email', validateEmail, Resources.VALIDATE_EMAIL);

/**
 * Add date validation method to jQuery validation plugin.
 * Text fields must have 'validate-date' css class to be validated
 */
$.validator.addMethod('validate-date', validateCCExpirationDate, Resources.VALIDATE_CCEXPIRATIONDATE);
 
/**
 * Add email validation method to jQuery validation plugin.
 * Text fields must have 'email-confirm' css class to be validated
 */
$.validator.addMethod('email-confirm', validateEmailConfirm, Resources.VALIDATE_EMAILCONFIRMATION);

/**
 * Add checkbox validation method to jQuery validation plugin.
 * Text fields must have 'validate-checkbox' css class to be validated
 */
$.validator.addMethod('validate-checkbox', validateCheckbox, Resources.VALIDATE_CHECKBOX);

/**
 * Add password validation method to jQuery validation plugin.
 * Text fields must have 'password-confirm' css class to be validated
 */
$.validator.addMethod('password-confirm', validatePassword, Resources.VALIDATE_PASSWORDCONFIRMATION);

/**
 * Add password validation method to jQuery validation plugin.
 * Text fields must have 'newpassword-confirm' css class to be validated
 */
$.validator.addMethod('newpassword-confirm', validateNewPassword, Resources.VALIDATE_NEWPASSWORDCONFIRMATION);

/**
 * Add password complexity validation method to jQuery validation plugin.
 * Text fields must have 'password-complexity' css class to be validated
 */
$.validator.addMethod('password-complexity', validatePasswordComplexity, Resources.VALIDATE_PASSWORDCOMPLEXITY);

/**
 * Add phone validation method to jQuery validation plugin.
 * Text fields must have 'phone' css class to be validated as phone
 */
$.validator.addMethod('phone', validatePhone, Resources.INVALID_PHONE);

/**
 * Add CCOwner validation method to jQuery validation plugin.
 * Text fields must have 'owner' css class to be validated as not a credit card
 */
$.validator.addMethod('owner', validateOwner, Resources.INVALID_OWNER);

/**
 * Add Postal code validation method to jQuery validation plugin.
 */
$.validator.addMethod('zipcode', validatePostal, Resources.INVALID_ZIP);

/**
 * Add gift cert amount validation method to jQuery validation plugin.
 * Text fields must have 'gift-cert-amont' css class to be validated
 */
$.validator.addMethod('gift-cert-amount', function (value, el) {
    var isOptional = this.optional(el);
    var isValid = (!isNaN(value)) && (parseFloat(value) >= 5) && (parseFloat(value) <= 5000);
    return isOptional || isValid;
}, Resources.GIFT_CERT_AMOUNT_INVALID);

/**
 * Add positive number validation method to jQuery validation plugin.
 * Text fields must have 'positivenumber' css class to be validated as positivenumber
 */
$.validator.addMethod('positivenumber', function (value) {
    if ($.trim(value).length === 0) { return true; }
    return (!isNaN(value) && Number(value) >= 0);
}, ''); // '' should be replaced with error message if needed

$.extend($.validator.messages, {
    required    : Resources.VALIDATE_REQUIRED,
    remote      : Resources.VALIDATE_REMOTE,
    email       : Resources.VALIDATE_EMAIL,
    url         : Resources.VALIDATE_URL,
    date        : Resources.VALIDATE_DATE,
    dateISO     : Resources.VALIDATE_DATEISO,
    number      : Resources.VALIDATE_NUMBER,
    digits      : Resources.VALIDATE_DIGITS,
    creditcard  : Resources.VALIDATE_CREDITCARD,
    equalTo     : Resources.VALIDATE_EQUALTO,
    maxlength   : $.validator.format(Resources.VALIDATE_MAXLENGTH),
    minlength   : $.validator.format(Resources.VALIDATE_MINLENGTH),
    rangelength : $.validator.format(Resources.VALIDATE_RANGELENGTH),
    range       : $.validator.format(Resources.VALIDATE_RANGE),
    max         : $.validator.format(Resources.VALIDATE_MAX),
    min         : $.validator.format(Resources.VALIDATE_MIN)
});

const customNamespacedValidationEvents = {
    pt_account() {
        $(document).on('change', '.validate-cc-exp-year', function () {
            $(this).closest('form').validate().element('.validate-date');
        });
    }
}

var validator = {
    regex    : regex,
    settings : settings,
    initCustomValidationEvents() {
        if (customValidatorsInitialized) {
            return;
        }

        const $currentWrapper = $('#wrapper');

        for (let validatorNamespace in customNamespacedValidationEvents) {
            if ($currentWrapper.hasClass(validatorNamespace)) {
                customNamespacedValidationEvents[validatorNamespace]();
                break;
            }
        }
        customValidatorsInitialized = true;
    },
    init     : function() {
        var self = this;
        $('form:not(.suppress)').each(function() {
            $(this).validate(self.settings);
            $(this).find('select').on('change', function() {
                $(this).valid();
            });
        });
        this.initCustomValidationEvents();
    },
    initForm: function (f) {
        $(f).validate(this.settings);
    }
};

module.exports = validator;
